module.exports = __webpack_public_path__ + "static/media/Market365SS.54b84218.png";